/* Number Utility */

// format thousand comma
function formatNumber(x) {
  if (x !== undefined) {
    // const val = Math.round((parseInt(x, 10) + Number.EPSILON) * 100) / 100;
    // fix safari remover val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parseFloat(x).toLocaleString();
  }

  return '';
}

// function thousandsSeparators(num) {
//   let numParts = num.toString().split('.');
//   numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   return numParts.join('.');
// }

export default formatNumber;
